import React, { useContext, useState, useEffect } from "react";
import Tooltip from "../tooltip/Tooltip";
import { prefixId } from "../kebab/Kebab";
import Icon from "../icons/Icon";
import Text from "../text/Text";
import TooltipText from "../tooltip/TooltipText";
import { ThemeContext } from "../../theme/ThemeProvider";
import { useNxTranslation } from "../../i18n/useNxTranslation";
import translationEN from "./locales/translation-en.json";
import translationFR from "./locales/translation-fr.json";
import useUniqueId from "../../hooks/useUniqueId";
import WithActionMenu from "../with-actionmenu/WithActionMenu";
import { HiddenButtonIcon } from "./KebabActionMenu.style";
import { usePrevious } from "@restart/hooks";
import { trapEvent } from "../../utils/EventHelpers";
export const MenuError = () => {
    const themeContext = useContext(ThemeContext);
    const { t, nxI18n } = useNxTranslation();
    nxI18n.addResources("en", "menu", translationEN);
    nxI18n.addResources("fr", "menu", translationFR);
    return (React.createElement(TooltipText, null,
        React.createElement(Icon, { name: "warning", style: { color: themeContext.colors.apolloColorTextError } }),
        React.createElement(Text, { role: "alert" },
            "\u00A0",
            t("actionMenuLoadingError", { ns: "menu" }))));
};
export const ErrorTooltip = ({ tooltipPosition }) => (React.createElement(Tooltip, { position: tooltipPosition },
    React.createElement(MenuError, null)));
// used by Kpi, InteractiveTag, FilterItem, Separator, SortableListItemll
const KebabActionMenu = (props) => {
    var _a;
    const kebabId = useUniqueId(prefixId, props.id);
    const [isMenuVisible, setIsMenuVisible] = useState(false);
    const previousIsVisible = usePrevious(isMenuVisible);
    const [forceFocusStyle, setForceFocusStyle] = useState(false);
    useEffect(() => {
        if (forceFocusStyle && previousIsVisible && !isMenuVisible) {
            setForceFocusStyle(false);
        }
    }, [isMenuVisible, previousIsVisible]);
    return (React.createElement(WithActionMenu, Object.assign({}, props, { id: `${kebabId}`, actions: props.actions, onMenuVisibilityChange: (e) => {
            setIsMenuVisible(e);
        } }),
        React.createElement(HiddenButtonIcon, Object.assign({ disabled: props.disabled, id: `${kebabId}_button`, isVisible: isMenuVisible, "data-visible": isMenuVisible }, (forceFocusStyle && { "data-focused": true }), { "data-insights": props["data-insights"] && `${props["data-insights"]}_button`, "aria-label": (_a = props["aria-label"]) !== null && _a !== void 0 ? _a : "actions", iconName: "kebab", variant: "round", onClick: (e) => {
                // set focus ring if it is a keyboard event
                if (e.nativeEvent.key) {
                    setForceFocusStyle(true);
                    trapEvent(e);
                }
            } }))));
};
export default KebabActionMenu;
//# sourceMappingURL=KebabActionMenu.js.map